export default __webpack_public_path__ + "static/media/no_zj.acac7c57.png";